import React, { Component } from 'react';
// import { Header } from '../common/header';
// import { Footer } from '../common/footer';
// import { SideBar } from '../common/sidebar';

import { TopBar } from '../common/topBar';
import { SideBar } from '../common/sidebar';

import AppUtils from '../apputils';
//import { PnkConnect } from '../pnk-react/pnk-miniredux';
//import $ from 'jquery';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
//import DialogContentText from '@material-ui/core/DialogContentText';
//import DialogTitle from '@material-ui/core/DialogTitle';
import FriendlyCallsModal from '../components/Home/FriendlyCallsModal';
import HowKinshipWorksModal from '../components/Home/HowKinshipWorksModal';

export default class SinglePageLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isModalOpen: false,
            isHKWorkModalOpen: false,
            currentModalAction: {},
            close: null,
            siderbarActive: '',
            isLoggedIn: false,
            display: 'none',
            check: 'ok',
        };
        this.comp = '';
        this.comp_size = 'md';
        this.routeArray = ['/user/new', '/users', '/leads'];
        this.prev_url = 'init';
        this.headerClass = '';
        this.active_url = '';

        this.AddClass = this.AddClass.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.sidebarId = ['home', 'upcoming-sessions', 'travel', 'all-games' , 'partner' , 'contact' , 'refer-earn'];

        // this.url = window.location.href;


        //  this.LogOut = this.LogOut.bind(this);
    }
    componentDidMount = () => {

      //  alert(this.active_url)

        // if(this.active_url === 'none'){
        //     // for(var i = 0 ; i<this.sidebarId.length; i++){
        //     //     var element = document.getElementById(this.sidebarId[i])
        //     //     element.classList.remove('active');
        //     // }
        //     alert(this.active_url);
        // }

        // for (var i = 0; i < this.sidebarId.length; i++) {
        //     if ((window.location.href).includes(this.sidebarId[i])) {
        //         this.active_url = this.sidebarId[i];
        //       //  if (this.state.siderbarActive !== this.active_url) {
        //          //    alert('hii' + this.active_url)

        //             //  this.setState({
        //             //      siderbarActive: this.active_url
        //             //  })
        //           //  alert(document.getElementById('home').innerHTML)
        //        // }

        //         //     var element = document.getElementById('home');

        //         //   element.classList.add('active')
        //     }
           
           
            
        // }

 

        if(this.active_url === ''){
            for(var i = 0; i<this.sidebarId.length; i++){
                var element = document.getElementById(this.sidebarId[i])
                element.classList.remove('active');
            }
        }

        else{
//  alert(this.active_url)
        var element2 = document.getElementById(this.active_url)

        element2.classList.add('active');
        }
    }

    componentWillReceiveProps = () => {
        if ((this.prev_url.indexOf('/lead/edit') > -1) && (window.location.href.indexOf('/lead/new') > -1) || (this.prev_url.indexOf('/booking/edit') > -1) && (window.location.href.indexOf('/booking/new') > -1)) {
            //AppUtils.HandlePageClick(this.props, 'lead/new')
            window.location.reload();
        }
        this.prev_url = window.location.pathname;
    }

    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }

    handleClickOpen = (comp_name, size = 'md', action = {}) => {
        //  alert("---"+(close));
        this.comp_size = size;
        this.comp = comp_name;
        // console.log("action",action)
        this.headerClass = action.headerClass
        this.setState({ open: true, currentModalAction: action });
    };

    ShowHowKinshipWorkModal = () => {
        //   alert('work');
        this.RemoveClass();
        this.setState({
            isHKWorkModalOpen: true
        })
    }

    HideHowKinshipWorkModal = () => {
        this.setState({ isHKWorkModalOpen: false })
    };

    ShowFriendlyCallsModal = () => {
        //  alert('work');
        this.RemoveClass();
        this.setState({
            isModalOpen: true
        })
    }
    HideFriendlyCallsModal = () => {
        this.setState({ isModalOpen: false })
    };


    handleClose = () => {
        if (document.getElementById('reloadList') != null)
            document.getElementById('reloadList').click();
        this.setState({ open: false });
        //  alert(this.props.componentprops)
    };

    Logout = () => {
        // sessionStorage.clear();
        localStorage.clear();
        this.setState({ loginStatus: 'logout' })
    }
    AddClass = () => {
        // alert('iiii');
        // this.setState({ siderbarActive: "sidebar-active",

        // display:'block'

        var element = document.getElementById("section-left");
        element.classList.add("sidebar-active");
        //    var element = document.getElementById("ddlTourPerson");
        //    element.classList.remove("active");
        // });
    }
    RemoveClass = () => {
        // this.setState({ siderbarActive: "" });
        var element = document.getElementById("section-left");
        element.classList.remove("sidebar-active");
    }
    render() {
        // alert('in render')

        for (var i = 0; i < this.sidebarId.length; i++) {
            if ((window.location.href).includes(this.sidebarId[i])) {
                this.active_url = this.sidebarId[i];
               
              //  if (this.state.siderbarActive !== this.active_url) {
                 //    alert('hii' + this.active_url)

                    //  this.setState({
                    //      siderbarActive: this.active_url
                    //  })
                  //  alert(document.getElementById('home').innerHTML)
               // }

                //     var element = document.getElementById('home');

                //   element.classList.add('active')
            }
           
            // else{
            //     this.active_url = '';
            // }
            
            
        }

        // var si =  hrf.slice(hrf.length , hrf.indexOf('/'));
        //alert(si)
        //  console.log(hrf)

        let access_route = false;
        for (let i = 0; i < this.routeArray.length; i++) {
            if (this.props.match.path === this.routeArray[i]) {
                access_route = true;
            }
        }
        // alert(''+access_route)
        let isLoggedIn = true;

        let timeToLogout = (new Date((localStorage.getItem('login_token_expire_time')))).getTime() - (new Date()).getTime();
        //alert(timeToLogout)

        setTimeout(() => {
            // sessionStorage.clear();
            localStorage.clear();
            //     window.location.reload();
            // if
        }, timeToLogout);




        //     let isLoggedIn = '';
        //    // alert(sessionStorage.getItem('current_user_login_token'));
        //     //alert(localStorage.getItem('current_user_login_token'));
        //     if (localStorage.getItem('current_user_name') == null && localStorage.getItem('current_user_login_token') == null) {
        //         isLoggedIn = false;
        //     }
        //     else {
        //         if (localStorage.getItem('current_user_name') !== null && localStorage.getItem('current_user_login_token') !== null && localStorage.getItem('current_user_profile') !== null)
        //             isLoggedIn = true;
        //         else
        //             isLoggedIn = false;
        //     }


        return (
            <div className="cbp-spmenu-push">
                {isLoggedIn ?
                    <div className="main-content">


                        {/* <SideBar {...this.props} />
                        <Header LogOut={this.LogOut} {...this.props} /> */}
                        <div class="home-main" style={{ display: 'flex' }}>
                            <div class="section-left" id="section-left" style={{ width: '15%' }}>
                                <SideBar {...this.props} Logout={this.Logout} check={this.state.check} RemoveClass={this.RemoveClass} AddClass={this.AddClass}
                                    HandleRouting={this.HandleRouting}
                                    ShowFriendlyCallsModal={this.ShowFriendlyCallsModal}
                                    ShowHowKinshipWorkModal={this.ShowHowKinshipWorkModal}
                                    active_url={this.active_url}
                                    siderbarActive={this.state.siderbarActive} />
                            </div>
                            <div class="section-right" style={{ width: '85%', padding: 0 }}>
                                <TopBar {...this.props} AddClass={this.AddClass} siderbarActive={this.state.siderbarActive} />

                                <this.props.children HandleCloseModal={this.handleClose} siderbarActive={this.state.siderbarActive} OpenModal={this.handleClickOpen} {...this.props} />

                            </div>

                            <FriendlyCallsModal {...this.props} isModalOpen={this.state.isModalOpen}
                                HideFriendlyCallsModal={this.HideFriendlyCallsModal}
                            />
                            <HowKinshipWorksModal {...this.props} isHKWorkModalOpen={this.state.isHKWorkModalOpen}
                                HideHowKinshipWorkModal={this.HideHowKinshipWorkModal}
                            />

                        </div>
                        <div>
                            <Dialog fullWidth maxWidth={this.comp_size} open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                                <DialogContent className={this.headerClass}>
                                    <this.comp currentAction={this.state.currentModalAction}
                                        closeModal={this.handleClose}
                                        {...this.props} />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleClose} color="primary">
                                        Cancel
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                    :
                    AppUtils.HandlePageClick(this.props, 'login')
                }
            </div>
        );
    }
}
const dialogPaper = {
    // minHeight: '80vh',
    // maxHeight: '80vh',
    maxWidth: 'lg'
}